import {gql} from '@apollo/client';

export const SEQUENCE_LENGTH_QUERY = gql`
  query SequenceLengthQuery($ids: [StrictString]!) @skipAudit @engComponent(name: SIGHTGLASS) {
    sequences(ids: $ids) {
      ... on SequenceNode {
        id
        length
      }
    }
  }
`;

export const AA_SEQUENCE_LENGTH_QUERY = gql`
  query AaSequenceLengthQuery($ids: [StrictString]!) @skipAudit @engComponent(name: SIGHTGLASS) {
    aaSequences(ids: $ids) {
      ... on AaSequenceNode {
        id
        length
      }
    }
  }
`;
